const TALENT_CARD_SORT_BASE_OPTIONS = [
  { value: 'created_at', label: 'Created' },
  { value: 'talent', label: 'Name' },
  { value: 'id', label: 'ID' },
  { value: 'status', label: 'Status' },
  { value: 'stage', label: 'Stage' },
  { value: 'talent_id', label: 'Talent ID' },
  { value: 'auth_user_id', label: 'Auth User' },
  { value: 'professions', label: 'Professions' },
  { value: 'public_slug', label: 'Slug' },
  { value: 'public_short_name', label: 'Short Name' },
  { value: 'public_rate', label: 'Rate' },
  { value: 'public_seo_title', label: 'SEO Title' },
  { value: 'public_seo_description', label: 'SEO Description' },
  { value: 'location', label: 'Location' },
  { value: 'active', label: 'Active' },
];

export const getTalentCardSortOptions = ({ nameLabel = 'Name', includeFavorite = false, includeStatusUpdated = false } = {}) => [
  ...(includeStatusUpdated ? [{ value: 'status_updated_at', label: 'Status updated' }] : []),
  ...TALENT_CARD_SORT_BASE_OPTIONS.map((option) => (
    option.value === 'talent' ? { ...option, label: nameLabel } : option
  )),
  ...(includeFavorite ? [{ value: 'favorited_at', label: 'Favorite' }] : []),
];

export const TALENT_POST_CARD_SORT_OPTIONS = [
  { value: 'name', label: 'Name' },
  { value: 'created_at', label: 'Created' },
  { value: 'planned_date', label: 'Planned date' },
];

export const JOB_APPLICATION_CARD_SORT_OPTIONS = [
  { value: 'name', label: 'Name' },
  { value: 'id', label: 'ID' },
  { value: 'manager_id', label: 'Manager' },
  { value: 'gender', label: 'Gender' },
  { value: 'age', label: 'Age' },
  { value: 'country_id', label: 'Location' },
  { value: 'status_id', label: 'Status' },
  { value: 'created_at', label: 'Created' },
];
